export interface WsState {
    hasPreviouslyOpenedConnection: boolean;
    isConnected: boolean;
    isAttemptingReconnect: boolean;
    revalidationSequence: number;
}

export interface WsConnectPayload {
    retryInterval: number;
}

export const UPDATE_WS_IS_CONNECTED = 'UPDATE_WS_IS_CONNECTED';
export const UPDATE_WS_IS_ATTEMPTING_RECONNECT = 'UPDATE_WS_IS_ATTEMPTING_RECONNECT';
export const REVALIDATE_REALTIME_STATE = 'REVALIDATE_REALTIME_STATE';

export const TRY_WEBSOCKET_CONNECT = 'TRY_WEBSOCKET_CONNECT';
export const TRY_WEBSOCKET_RECONNECT = 'TRY_WEBSOCKET_RECONNECT';
export const TRY_WEBSOCKET_DISCONNECT = 'TRY_WEBSOCKET_DISCONNECT';

export interface UpdateWsConnectedPayload {
    isConnected: boolean;
}

export interface UpdateWsIsAttemptingReconnectPayload {
    isAttemptingReconnect: boolean;
}

export interface UpdateWsConnectedAction {
    type: typeof UPDATE_WS_IS_CONNECTED;
    payload: UpdateWsConnectedPayload;
}

export interface UpdateWsIsAttemptingReconnectAction {
    type: typeof UPDATE_WS_IS_ATTEMPTING_RECONNECT;
    payload: UpdateWsIsAttemptingReconnectPayload;
}

export interface RevalidateRealtimeStateAction {
    type: typeof REVALIDATE_REALTIME_STATE;
}

export interface TryWebsocketConnectAction {
    type: typeof TRY_WEBSOCKET_CONNECT;
}

export interface TryWebsocketReconnectAction {
    type: typeof TRY_WEBSOCKET_RECONNECT;
    payload: WsConnectPayload;
}

export interface TryWebsocketDisconnectAction {
    type: typeof TRY_WEBSOCKET_DISCONNECT;
}

export type UpdateWsConnectedActionType =
    | UpdateWsConnectedAction
    | UpdateWsIsAttemptingReconnectAction
    | RevalidateRealtimeStateAction;

// Action Creators

export const updateWsConnected: (payload: UpdateWsConnectedPayload) => UpdateWsConnectedAction = (payload) => {
    return {
        type: UPDATE_WS_IS_CONNECTED,
        payload,
    };
};

export const updateWsAttemptingReconnect: (
    payload: UpdateWsIsAttemptingReconnectPayload,
) => UpdateWsIsAttemptingReconnectAction = (payload) => {
    return {
        type: UPDATE_WS_IS_ATTEMPTING_RECONNECT,
        payload,
    };
};

export const revalidateRealtimeState = (): RevalidateRealtimeStateAction => {
    return {
        type: REVALIDATE_REALTIME_STATE,
    };
};

export const tryWebsocketConnect: () => TryWebsocketConnectAction = () => {
    return {
        type: TRY_WEBSOCKET_CONNECT,
    };
};

export const tryWebsocketReconnect: (payload: WsConnectPayload) => TryWebsocketReconnectAction = (payload) => {
    return {
        type: TRY_WEBSOCKET_RECONNECT,
        payload,
    };
};

export const tryWebsocketDisconnect: () => TryWebsocketDisconnectAction = () => {
    return {
        type: TRY_WEBSOCKET_DISCONNECT,
    };
};
